<template>

  <div class="funcao-cadastro ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <b-col cols="6">
                <label for="select-empresa">Empresa</label> 
                <multiselect  id="selecao-empresa-sol"  v-model="funcoes.id_empresa" required                  
                  :options="empresas" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"                   
                  :preserve-search="true" placeholder="Selecione a empresa" label="empresa" track-by="empresa" name="empresa"
                  :preselect-first="true">                   
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>              

              <b-col cols="2">
                <br>
                <b-button variant="warning" block class="ml-2 mt-2 mr-2" v-b-modal.modal-multi-1 @click="reset()">Novo</b-button>
              </b-col>

              <b-col cols="4" >
                <label  for="input-busca">Pesquisa no grid  </label>  
                <b-form-input id="buscafuncao" class="ml-2 mr-5" v-model="search"  required="required" placeholder="Função"></b-form-input>              
              </b-col>                 

          </b-row>
    </b-form>

    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
    <b-table id="funcoes"  small hover striped sticky-header="880px"  :items="itemsFuncaoFiltrar" :fields="fields" >    
        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="editFuncao(data.item)"    title="Editar Função"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-multi-1>                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>   
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <div>        
    <b-modal id="modal-multi-1"   hide-footer size="lg" title="Cadastro de Função">
          <!-- -->
          <div>
            <b-row>
              <b-col cols="9">
                <label for="input-live">Função</label> 
                <b-form-input v-model="funcao.funcao" placeholder="Digite a descrição da função"></b-form-input>              
              </b-col>
          </b-row>  

          <b-button class="mt-3" variant="success" block @click="postFuncao()">Gravar</b-button>            
          </div>          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>  
</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import { mapState } from 'vuex' 


export default {    
    name: 'FuncionarioFuncao', 

    
    computed : { ... mapState (['user'],),
      itemsFuncaoFiltrar(){
          let valorefuncao = [];       
          valorefuncao = this.funcoes.filter((item) =>{
            return (
              item.funcao.indexOf(this.search) >-1
            );
          });
          return valorefuncao
      },

    },
    
    

    data: function() {

        
      
        return {            
            mode: 'save',
            carregando: false,
            atualizando: false,   

            empresas:[],
            funcoes:[],
            funcao: {},  // criando o objeto a ser editado no modal
            search: '',            

            fields: [
                { key: 'id_funcao', label: 'id', sortable: true },     
                { key: 'id_empresa', label: 'Empresa', sortable: true },                 
                { key: 'funcao', label: 'Função', sortable: true },                               
                { key: 'dt_cadastro', label: 'Data Cadastro', sortable: true, formatter: (value, key, funcoes) => {
                    return moment(funcoes.dt_cadastro).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },
                { key: 'actions', label: 'Ações' },                
            ]
        }        
    },

    components: {
        Multiselect
    },

    methods: {

      loadEmpresa() {
            let params = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,  
                   "psg": this.user.id_empresa == 2 ? 'PSG_ML18' : this.user.psg // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste                                          
            };

          const url = `${baseApiUrl}/ctr/empresa`
          axios.get(url,{params})
          .then(res => {this.empresas = res.data.map(emp => {return { ... emp, value: emp.id_empresa, empresa: emp.nomeempresarial, id_filial_erp: emp.id_filial_erp } })})
          .catch(showError)
      },

      loadFuncoes() {
            let params = {    
                id_empresa: `${this.user.id_empresa}`, 
                origem: 'CAD'  ,
                psg: this.user.id_empresa == 2 ? 'PSG_ML18' : this.user.psg // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste                                          
            };
          const url = `${baseApiUrl}/folha/funcionario/funcao`
          axios.get(url,{params})
            .then(res => {
              this.funcoes = res.data.map(func => {                      
                return { ... func, value: func.id_funcao_erp, funcao: func.funcao }  //// para pegar o valor tem que usar o ... atribuicao value
              })
            })
            .catch(showError)
      },

      postFuncao() {
            let corpo = {    
                "id_empresa": `${this.user.id_empresa}`,                                            
                "id_funcao": `${this.funcao.id_funcao}`,                                            
                "funcao": `${this.funcao.funcao}`,  
                   "psg": this.user.id_empresa == 2 ? 'PSG_ML18' : this.user.psg // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste                                                                                    
            };
          const url = `${baseApiUrl}/folha/funcionario/funcao`
          axios.post(url,corpo)
               .then(() => {                                             
                this.$toasted.global.defaultSuccess(),                    
                this.reset() //limpar os objetos valores            
                })
               .catch(showError)            
      },

      reset() {            
            this.funcoes = {}
            this.loadFuncoes()            
      },

      editFuncao(funcao){
            this.funcao = { ...funcao }
      },      
    },

    mounted() {        
      this.loadFuncoes() 
      this.loadEmpresa()  
      this.editFuncao()     
    },



}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>





</style>